<script>
export default {
  name: "AdminEditableName",
  props: {
    producto: { type: Object, required: true },
    isAdmin: { type: Boolean, required: true },
  },
  computed: {
    editable() {
      return Boolean(this.isAdmin && this.producto.nombreEditado);
    },
  },
  data() {
    return {
      nombreEditado: this.producto.nombreEditado || this.producto.nombre,
      height: "20px",
    };
  },
  watch: {
    // Actualiza altura del textarea con la del título
    editable: {
      handler: function (editable) {
        if (!editable) return;
        this.height = this.$refs.contenedor.clientHeight + "px";
      },
    },
    nombreEditado: {
      handler: function (nombreEditado) {
        this.$emit("update:producto", { nombreEditado });
      },
    },
  },
};
</script>
<template>
  <div>
    <textarea
      v-show="editable"
      v-model="nombreEditado"
      :style="{ height }"
    ></textarea>
    <div v-show="!editable" ref="contenedor">
      <slot></slot>
    </div>
  </div>
</template>